import React, { useEffect, useState } from "react";
import { kmMethodsByJob, selectKmMethod } from "../../../api/jobApi";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { inputFieldProfile } from "../../../const";
import Button from "../../input/Button";
import LoadingSpinner from "../../LoadingSpinner";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const getKmActualValue = (value) => {
  switch (value) {
    case -1: {
      return (
        <div style={{ color: "lightcoral" }}>
          Error Occurred while calculating!
        </div>
      );
    }
    case -2: {
      return (
        <div style={{ color: "#ffbf00" }}>
          Vehicle is not a GPS enabled vehicle!
        </div>
      );
    }
    case -3: {
      return <div style={{ color: "#ffbf00" }}>No history records found!</div>;
    }
    case -4: {
      return (
        <div style={{ color: "#ffbf00" }}>
          Add Km manually due to KM deviation
        </div>
      );
    }
    default: {
      return <div style={{ color: "grey" }}>{`${value} Km`}</div>;
    }
  }
};

const DropdownContent = ({ title, value }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h5>{title}</h5>
      {getKmActualValue(value)}
    </div>
  );
};

const JobKmMethodSelection = ({
  jobId,
  reqId,
  customerId,
  close,
  viewMode,
  kmActual,
}) => {
  const user = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const [kmMethods, setKmMethods] = useState([]);
  const [kmValue, setKmValue] = useState(null);
  const [kmId, setKmId] = useState(null);
  const [currentErrors, setCurrentErrors] = useState({
    kmId: null,
    kmValue: null,
  });
  const [addedManually, setAddedManually] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await kmMethodsByJob(jobId);
      if (viewMode) {
        const selectedValue = response.find((res) => res.selected);
        setAddedManually(!selectedValue);
        setKmMethods(response);
      } else {
        const kmMethodDropdownData = response.map((item) => ({
          key: item.jkcId,
          text: item.jkcConfigName,
          value: {
            id: item.jkcId,
            value: item.jkcKm,
          },
          content: (
            <DropdownContent title={item.jkcConfigName} value={item.jkcKm} />
          ),
        }));
        kmMethodDropdownData.push({
          key: -1,
          text: "Manual",
          value: {
            id: -1,
            value: "Manual",
          },
          content: <DropdownContent title="Manual" value={-4} />,
        });
        setKmMethods(kmMethodDropdownData);
      }
      setIsLoading(false);
    })();
  }, [jobId, viewMode]);

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      let errors = false;
      if (kmId === null) {
        setCurrentErrors((prevState) => ({
          ...prevState,
          kmId: "KM Method is mandatory",
        }));
        errors = true;
      }
      if (kmValue === null || kmValue === "") {
        setCurrentErrors((prevState) => ({
          ...prevState,
          kmValue: "KM Value is mandatory",
        }));
        errors = true;
      }
      if (errors) {
        return;
      }
      setIsSubmitLoading(true);
      await selectKmMethod({
        jobId,
        reqId,
        customerId,
        jkcId: kmId,
        kmValue,
        isManual: kmId === -1,
      });
      close();
      toast.success("KM method selected successfully", {
        autoClose: 5000,
        containerId: "Modal",
      });
    } catch (e) {
      toast.error("Error selecting km method", {
        autoClose: 5000,
        containerId: "Modal",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <div className="ui form">
        {isLoading ? (
          <LoadingSpinner height="300px" />
        ) : (
          <div className="ui segment" style={{ height: "300px" }}>
            <h4 className="ui dividing header">{`KM Method ${viewMode ? "view" : "selection"}`}</h4>
            {viewMode ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {addedManually && (
                  <div
                    style={{
                      display: "flex",
                      height: "40px",
                      width: "500px",
                      gap: "5px",
                      padding: "5px",
                    }}
                  >
                    <div style={{ height: "100%", width: "200px" }}>
                      Added Manually :
                    </div>
                    <div
                      style={{
                        height: "100%",
                        border: "2px solid black",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      {kmActual} Km
                    </div>
                  </div>
                )}
                {kmMethods.map((kmMethod) => (
                  <div
                    style={{
                      display: "flex",
                      height: "40px",
                      width: "500px",
                      padding: "5px",
                    }}
                  >
                    <div style={{ height: "100%", width: "200px" }}>
                      {kmMethod.jkcConfigName} :
                    </div>
                    <div
                      style={{
                        height: "100%",
                        gap: "5px",
                        border: kmMethod.selected ? "2px solid black" : "none",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      {getKmActualValue(kmMethod.jkcKm)}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <div className="field">
                  <Dropdown
                    required={true}
                    label="KM Methods"
                    error={currentErrors.kmId}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { kmId: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="KM Method"
                    options={kmMethods}
                    style={{ height: "20px" }}
                    onChange={(e, data) => {
                      if (data.value) {
                        setKmId(data.value.id);
                        if (data.value.id === -1) {
                          setKmValue("");
                        } else {
                          setKmValue(
                            data.value.value >= 0 ? data.value.value : "",
                          );
                        }
                      }
                    }}
                  />
                </div>
                <div className="field">
                  <Input
                    readOnly={kmId !== -1}
                    required={true}
                    label="KM Value"
                    placeholder="KM Value"
                    error={currentErrors.kmValue}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { kmValue: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    profile={inputFieldProfile.DECIMAL}
                    value={kmValue}
                    onChange={(e) => {
                      setKmValue(e.target.value);
                    }}
                  />
                </div>
              </>
            )}
            {!viewMode && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="create"
                  editMode={false}
                  create={true}
                  onClick={onSubmitHandler}
                  isLoading={isSubmitLoading}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default JobKmMethodSelection;
